import {motion} from "motion/react"
import { useState } from "react";
import { useTheme } from 'next-themes';

const DarkModeButton = () => {

    const [isOn, setIsOn] = useState(true)
    const { theme, setTheme } = useTheme();

    const changeTheme = () => {
        setTheme(theme === 'dark' ? 'light' : 'dark')
        setIsOn(!isOn)
        
    }

    return(
        <div className="dark:text-white text-black hidden z-50 md:flex h-4 lg:h-6 items-center gap-3 text-xs lg:text-base m-2 ani-enter-bot">
            <div className="dark:text-gray text-darkgray">THIS</div>
            <div className='flex border-solid dark:justify-start justify-end border-white border-[1px] w-8 lg:w-12 h-full rounded-full' 
                 onClick={() => changeTheme()} 
                 >

                <motion.div layout 
                            className="h-full aspect-square bg-white rounded-full border-black border-4 border-solid"
                            initial={{opacity: 0, x: 0}}
                            animate={{opacity: 1, x: 0}}
                            transition={{
                                type: "spring",
                                visualDuration: 0.1,
                                bounce: 0.2,
                            }}>
                </motion.div>
            </div>
            <div className="dark:text-gray text-darkgray">THAT</div>
        </div>
    )
}

export default DarkModeButton;